import 'reflect-metadata';
import { Type, Property } from '@dipscope/type-manager';

import { Color } from '../../core/Player';

export enum MeepleType {
  meeple = 'meeple',
  giant = 'giant',
  builder = 'builder',
  pig = 'pig',
  ship = 'ship'
}

export const countableMeepleTypes: MeepleType[] = [MeepleType.meeple, MeepleType.giant, MeepleType.ship];

export const MeepleTypeMap: { [key in MeepleType]: number } = {
  meeple: 1,
  giant: 2,
  builder: 0,
  pig: 1,
  ship: 1
};

@Type({ injectable: true, discriminant: 'Meeple' })
export class Meeple {
  @Property()
  id: number;
  @Property()
  type: MeepleType;
  @Property()
  value: number;
  @Property()
  playerId: number;
  @Property()
  color: Color;
  @Property()
  recovered: boolean = false;
  @Property()
  tileId: number;
  @Property()
  nodeId: number;
  @Property()
  nodeType: string;
  @Property()
  score: number = 0;

  toDTO() {
    return {
      id: this.id,
      type: this.type,
      value: this.value,
      playerId: this.playerId,
      color: this.color,
      recovered: this.recovered,
      nodeId: this.nodeId,
      nodeType: this.nodeType,
      tileId: this.tileId,
      score: this.score
    };
  }

  static fromDTO(dto: MeepleDTO): Meeple {
    const meeple = new Meeple();
    meeple.id = dto.id;
    meeple.type = dto.type;
    meeple.value = dto.value;
    meeple.playerId = dto.playerId;
    meeple.color = dto.color;
    meeple.recovered = dto.recovered;
    meeple.nodeId = dto.nodeId;
    meeple.tileId = dto.tileId;
    meeple.nodeType = dto.nodeType;
    meeple.score = dto.score;
    return meeple;
  }
}

@Type({ injectable: true })
export class MeepleDTO {
  @Property()
  id: number;
  @Property()
  type: MeepleType;
  @Property()
  value: number;
  @Property()
  playerId: number;
  @Property()
  color: Color;
  @Property()
  recovered: boolean;
  @Property()
  nodeId: number;
  @Property()
  tileId: number;
  @Property()
  nodeType: string;
  @Property()
  score: number;
}
